import React from "react";

export const CancellationPolicy = () => {
  return (
    <div className="min-h-screen bg-gray-50 py-10 px-4">
      <div className="max-w-5xl mx-auto bg-white shadow-lg rounded-2xl overflow-hidden">
        
        {/* Header */}
       <div className="bg-gradient-to-r from-orange-500 via-orange-600 to-amber-500 px-8 py-12 text-white">
  <h1 className="text-4xl font-bold mb-3">
    Cancellation Policy
  </h1>
  <p className="text-lg text-orange-100">
    Please review our cancellation terms carefully before placing or
    canceling any order or service request.
  </p>
</div>

        {/* Content */}
        <div className="p-8 md:p-10 text-gray-700 leading-relaxed space-y-8">
          
          <section>
            <h2 className="text-2xl font-semibold text-gray-900 mb-3">
              1. Order Cancellation
            </h2>
            <p>
              Customers may request cancellation of their order within a
              specified time after placing it. Once the order has been
              processed, shipped, or approved, cancellation requests may not
              be accepted.
            </p>
          </section>

          <section>
            <h2 className="text-2xl font-semibold text-gray-900 mb-3">
              2. Cancellation Eligibility
            </h2>
            <p>
              Cancellation requests are subject to verification and approval.
              Certain products, customized services, digital products, or
              time-sensitive bookings may not be eligible for cancellation.
            </p>
          </section>

          <section>
            <h2 className="text-2xl font-semibold text-gray-900 mb-3">
              3. Refund on Cancellation
            </h2>
            <p>
              If your cancellation request is approved, eligible refunds will
              be processed according to our refund policy. Processing time may
              vary depending on the payment method and financial institution.
            </p>
          </section>

          <section>
            <h2 className="text-2xl font-semibold text-gray-900 mb-3">
              4. Service Cancellation
            </h2>
            <p>
              For service-based requests, cancellations made before service
              initiation may be eligible for a full or partial refund.
              Cancellation after work commencement may result in deductions or
              non-refundable charges.
            </p>
          </section>

          <section>
            <h2 className="text-2xl font-semibold text-gray-900 mb-3">
              5. Company Rights
            </h2>
            <p>
              We reserve the right to cancel any order, booking, or service
              due to unforeseen circumstances, payment issues, unavailability,
              policy violations, or incorrect information provided by the
              customer.
            </p>
          </section>

          <section>
            <h2 className="text-2xl font-semibold text-gray-900 mb-3">
              6. Contact Us
            </h2>
            <p>
              If you have any questions regarding cancellations, please contact
              our support team for assistance. We will do our best to resolve
              your concerns promptly.
            </p>
          </section>
        </div>
      </div>
    </div>
  );
};

export default CancellationPolicy;